

export const FETCH_ASSIGNEE_REQUEST = 'FETCH_ASSIGNEE_REQUEST';
export const FETCH_ASSIGNEE_REQUEST_COMPLETED = 'FETCH_ASSIGNEE_REQUEST_COMPLETED';
export const FETCH_ASSIGNEE_REQUEST_ERROR = 'FETCH_ASSIGNEE_REQUEST_ERROR';
export const FETCH_ASSIGNEE_RESET = 'FETCH_ASSIGNEE_RESET';

export const FETCH_ASSIGNEE_LIST_REQUEST = 'FETCH_ASSIGNEE_LIST_REQUEST';
export const FETCH_ASSIGNEE_LIST_REQUEST_COMPLETED = 'FETCH_ASSIGNEE_LIST_REQUEST_COMPLETED';
export const FETCH_ASSIGNEE_LIST_REQUEST_ERROR = 'FETCH_ASSIGNEE_LIST_REQUEST_ERROR';
export const FETCH_ASSIGNEE_LIST_RESET = 'FETCH_ASSIGNEE_LIST_RESET';

export const FETCH_ASSIGNEE_USER_LIST_REQUEST = 'FETCH_ASSIGNEE_USER_LIST_REQUEST';
export const FETCH_ASSIGNEE_USER_LIST_REQUEST_COMPLETED = 'FETCH_ASSIGNEE_USER_LIST_REQUEST_COMPLETED';
export const FETCH_ASSIGNEE_USER_LIST_REQUEST_ERROR = 'FETCH_ASSIGNEE_USER_LIST_REQUEST_ERROR';

export const ADD_ASSIGNEE_INITIAL = 'ADD_ASSIGNEE_INITIAL';
export const ADD_ASSIGNEE_REQUEST = 'ADD_ASSIGNEE_REQUEST';
export const ADD_ASSIGNEE_REQUEST_COMPLETED = 'ADD_ASSIGNEE_REQUEST_COMPLETED';
export const ADD_ASSIGNEE_REQUEST_ERROR = 'ADD_ASSIGNEE_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/assigneedetails.js